(function(){
 'use strict';
 if(window.__zentoraV131Reviews)return;window.__zentoraV131Reviews=true;
 function boot(){
  var root=document.querySelector('[data-zv9-product]');
  var card=root&&root.querySelector('.z163-reviews');
  var host=card&&card.querySelector('[data-zv114-app-reviews]');
  if(!card||!host)return;
  var intro=card.querySelector('[data-z158-review-fallback]');
  var write=card.querySelector('[data-z158-write-review]');
  var label=card.querySelector('[data-z163-write-label]');
  var badge=card.querySelector('[data-z163-review-count]');
  var status=card.querySelector('[data-z163-review-status]');
  var elapsed=false,writing=false;
  function nativeAction(){
   return host.querySelector('.jdgm-write-rev-link,.jdgm-write-review-btn,.jm-write-review-btn,[data-action="write-review"]')||
    Array.from(host.querySelectorAll('button,a,[role="button"]')).find(function(e){return /^(write (a |the first )?review|be the first to write a review)$/i.test(e.textContent.trim());});
  }
  function refresh(){
   var reviews=host.querySelectorAll('.jm-review-item,.jdgm-rev,.jdgm-review-content__body-content');
   var populated=Array.from(reviews).filter(function(e){return e.textContent.trim().length>0;}).length>0;
   var action=nativeAction(),form=host.querySelector('.jdgm-form,.jm-review-form,form');
   var raw=card.dataset.z158KnownCount;
   var count=raw!==undefined&&raw!==''&&/^\d+$/.test(raw)?Number(raw):null;
   var provider=host.querySelector('[data-number-of-reviews]');
   if(provider&&/^\d+$/.test(provider.getAttribute('data-number-of-reviews')||''))count=Number(provider.getAttribute('data-number-of-reviews'));
   var emptyText=/be the first to write a review|no reviews yet/i.test(host.textContent);
   if(!populated&&(emptyText||action)&&count===null)count=0;
   if(populated&&count===0)count=null;
   var empty=!populated&&count===0;
   card.hidden=false;
   card.dataset.zv130ReviewState=populated||action||form?'ready':'unavailable';
   card.classList.toggle('z163-show-native',populated||writing);
   card.classList.toggle('z163-writing',writing);
   if(intro)intro.hidden=populated;
   if(write){write.disabled=!action&&!form;write.hidden=writing;}
   if(label)label.textContent=empty?'Write the first review':'Write a review';
   if(badge){badge.hidden=count===null;badge.textContent=count===null?'':count+' '+(count===1?'review':'reviews');}
   if(status)status.textContent=empty?'No reviews yet for this product.':populated?'':elapsed?'Reviews are temporarily unavailable. Please try again later.':'Loading reviews…';
  }
  card.open=true;card.hidden=false;card.classList.remove('zv130-review-pending');
  if(write)write.addEventListener('click',function(){
   var action=nativeAction(),form=host.querySelector('.jdgm-form,.jm-review-form,form');
   if(!action&&!form)return;
   writing=true;refresh();
   if(action)action.click();
   else if(form){form.hidden=false;form.style.display='block';form.scrollIntoView({behavior:'smooth',block:'center'});form.querySelector('input,textarea')?.focus();}
  });
  host.addEventListener('click',function(event){
   var control=event.target.closest('button,a,[role="button"]');
   if(control&&/^(cancel|close)$/i.test(control.textContent.trim())){writing=false;setTimeout(refresh,0);}
  });
  refresh();
  if(window.MutationObserver)new MutationObserver(refresh).observe(host,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['data-number-of-reviews']});
  setTimeout(function(){elapsed=true;refresh();},8500);
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
